module.exports = __webpack_public_path__ + "img/bg-dot-pattern-long.93c5d8e1.svg";